var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 16C11.8326 16 11.6706 15.9695 11.5141 15.9084C11.3567 15.8473 11.2257 15.7659 11.1211 15.6641L5.34529 10.0458C5.1151 9.82188 5 9.53689 5 9.19084C5 8.84478 5.1151 8.5598 5.34529 8.33588C5.57549 8.11196 5.86846 8 6.22422 8C6.57997 8 6.87294 8.11196 7.10314 8.33588L12 13.0992L16.8969 8.33588C17.1271 8.11196 17.42 8 17.7758 8C18.1315 8 18.4245 8.11196 18.6547 8.33588C18.8849 8.5598 19 8.84478 19 9.19084C19 9.53689 18.8849 9.82188 18.6547 10.0458L12.8789 15.6641C12.7534 15.7863 12.6173 15.8726 12.4709 15.9231C12.3244 15.9744 12.1674 16 12 16Z",
    fill: "#747474"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow_down.a0479ae4.svg";
export { ForwardRef as ReactComponent };